/** @module csi/heading/RefNoLink */
define([
	"dojo/_base/declare",
	"csi/heading/Ref"
], function(declare,Ref) {
	return declare([Ref], {
		/**
		* Prevents a link from being established by returning null when this render is used
		* @return null
		*/
		_getLinkNode: function(ctx, h, source) {
			return null;
		}
	});
});